<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.8 0H2.6C1.17 0 0 1.17 0 2.6V20.8C0 22.2313 1.17 23.4 2.6 23.4H11.7V14.3H9.1V11.0825H11.7V8.4175C11.7 5.6043 13.2756 3.6283 16.5958 3.6283L18.9397 3.6309V7.0174H17.3836C16.0914 7.0174 15.6 7.9872 15.6 8.8868V11.0838H18.9384L18.2 14.3H15.6V23.4H20.8C22.23 23.4 23.4 22.2313 23.4 20.8V2.6C23.4 1.17 22.23 0 20.8 0Z"
      fill="currentColor"
    />
  </svg>
</template>
